<template>
  <v-container class="my-0 py-1" fluid>
    <v-dialog v-model="asignCecos" max-width="400px" persistent v-if="selected">
      <!-- Asignación de CECOS -->
      <v-card>
        <v-card-title>
          <small class>Asignación de Centros de costo - {{ this.selected.name }}</small>
        </v-card-title>
        <form @submit.prevent="assignCecos">
          <v-card-text>
            <v-autocomplete
              v-model="selectedCecos"
              label="Centros de costo"
              :items="cecos"
              outlined
              item-text="name"
              item-value="id"
              multiple
              chips
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="green darken-1" type="submit" dark>Guardar</v-btn>
            <v-btn color="error" @click="asignCecos = false">Cancelar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createDialog" max-width="400" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ nuevo.id ? 'Editar' : 'Nueva' }} cuenta de usuario</span>
        </v-card-title>

        <v-form
          v-model="form.valid"
          ref="form"
          lazy-validation
        >
          <v-card-text>
            <v-container>
              <v-text-field
                label="Usuario"
                outlined
                :rules="[form.rules.required]"
                v-model="nuevo.usr"
                :disabled="nuevo.id"
              ></v-text-field>
              <v-text-field
                label="Nombre"
                outlined
                :rules="[form.rules.required]"
                v-model="nuevo.name"
              ></v-text-field>
              <v-text-field
                label="Email"
                outlined
                type="email"
                :rules="[form.rules.required]"
                v-model="nuevo.email"
              ></v-text-field>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="error" @click.stop="nuevo = {};createDialog = false">Cancelar</v-btn>
            <v-btn
              color="success"
              :disabled="!form.valid"
              @click.prevent="crearOrUpdateCuenta"
            >{{ nuevo.id ? 'Editar' : 'Crear' }} cuenta</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col class="col-3">
        <v-text-field
          placeholder="Buscar usuario..."
          v-model="search"
          hide-details
          append-icon="search"
        ></v-text-field>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="createDialog = true"
        >Crear cuenta de usuario</v-btn>
      </v-col>
    </v-row>

    <v-data-table :headers="headers" :items="cuentas" :search="search" :items-per-page="5">
      <template v-slot:item.email="{ item }">
        {{ item.email }}
        <v-dialog v-model="emailDialog" max-width="300px" persistent>
          <template v-slot:activator="{ on }">
            <v-chip
              color="error"
              link
              v-if="!item.email"
              v-on="on"
              small
              @click.stop="showUpdateEmail(item)"
            >No tiene correo</v-chip>
          </template>
          <v-card>
            <form @submit.prevent="updateEmail">
              <v-card-text>
                <span>Ingrese su email</span>
                <v-text-field
                  v-model="selected.email"
                  hint="sucorreo@sudominio.com"
                  label="Email"
                  type="email"
                  required
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="red darken-1" text @click.stop="emailDialog = false">Cancelar</v-btn>
                <v-btn color="blue darken-1" text type="submit">Guardar</v-btn>
              </v-card-actions>
            </form>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.acciones="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              color="primary"
              v-on="on"
              @click.stop="changeState(item)"
              v-if="item.id !== auth.getUser().id"
            >
              <i class="fa fa-lock" v-if="item.enabled"></i>
              <i class="fa fa-unlock" v-if="!item.enabled"></i>
            </v-btn>
          </template>
          <span v-if="item.enabled">Bloquear usuario</span>
          <span v-if="!item.enabled">Desbloquear usuario</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              color="warning"
              v-on="on"
              v-if="item.id !== auth.getUser().id"
              @click="nuevo = item; createDialog = true"
            >
              <i class="fa fa-pencil"></i>
            </v-btn>
          </template>
          <span>Editar usuario</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              color="error"
              v-on="on"
              v-if="item.id !== auth.getUser().id"
              @click.stop="deleteUsuario(item)"
            >
              <i class="fa fa-trash"></i>
            </v-btn>
          </template>
          <span>Eliminar usuario</span>
        </v-tooltip>

        <v-tooltip bottom v-if="item.rol !== 'ADMIN'">
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              color="primary"
              v-on="on"
              v-if="item.id !== auth.getUser().id"
              @click="selected = item; getAssignedCecos(); asignCecos = true"
            >
              <i class="fa fa-chain"></i>
            </v-btn>
          </template>
          <span>Asignar Punto</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import Vue from "vue";
import { Auth } from "../../../classes/Auth";
import axios from "axios";
import moment from "moment";
import { apiv1 } from "../../../libs/apiv1";

const auth = new Auth();

export default Vue.extend({
  name: "Usuarios",
  data: () => ({
    loading: false,
    selected: {},
    nuevo: {},
    asignCecos: false,
    createDialog: false,
    emailDialog: false,
    auth: auth,
    headers: [
      { text: "Nombre", value: "name" },
      { text: "Usuario", value: "usr" },
      { text: "Correo", value: "email" },
      { text: "Última vez", value: "lastlogin" },
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false
      }
    ],
    cuentas: [],
    cecos: [],
    sucursales: [],
    assignedCecos: [],
    selectedCecos: [],
    search: null,
    form: {
      valid: true,
      rules: {
        required: value => !!value || "Este campo es obligatorio"
      }
    }
  }),
  mounted() {
    this.getUsers();
    this.getCecos();
  },
  methods: {
    getSucursales: function() {
      const fd = new FormData();
      fd.set("username_admin", auth.getUser().usr);
      axios({
        method: "POST",
        url: `${process.env.VUE_APP_BACKEND_FACTURACION}/ajax/smartchronos/query/filtro:listarsucursales`,
        data: fd
      }).then(res => {
        if (res.data.data) {
          if (!(res.data.data.length > 0)) {
            this.sucursales = [];
            this.$awn.warning(
              "No se encontraron sucursales para el usuario administrador."
            );
            return;
          }
          this.sucursales = res.data.data;
        } else {
          this.sucursales = [];
          this.$awn.alert("Ocurrió un error");
        }
      });
    },
    getCecos: function() {
      const project = auth.getProject();
      if (project) {
        apiv1({
          method: "GET",
          url: `cecos?project=${project.id}`
        }).then(res => {
          this.cecos = res.data;
        });
      } else {
        this.cecos = [];
      }
    },
    getUsers: function() {
      const project = auth.getProject();
      if (project) {
        apiv1({
          method: "GET",
          url: `users?project=${project.id}`
        }).then(res => {
          const data = res.data.map(function(item) {
            if (item.lastlogin) {
              item.lastlogin = moment(item.lastlogin).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
            return item;
          });
          this.cuentas = res.data;
        });
      } else {
        this.cuentas = [];
      }
    },
    changeState: function(item) {
      apiv1({
        method: "PUT",
        url: `user/change-state/${item.id}`
      }).then(res => {
        this.getUsers();
        this.$awn.success(res.data);
      });
    },
    crearOrUpdateCuenta: function() {
      if (this.$refs.form.validate()) {
        
        let url = `user`;
        let method = "POST";
        this.nuevo.project = auth.getProject().id;

        if (this.nuevo.id) {
          url = `user/${this.nuevo.id}`;
          method = "PUT";
          delete this.nuevo.project;
        } 

        this.loading = true;
        this.$awn.async(
          apiv1({
            method: method,
            url: url,
            data: {
              datos: this.nuevo,
              rol: auth.getUser().rol
            }
          }),
          res => {
            this.nuevo = {};
            this.createDialog = false;
            this.loading = false;
            this.getUsers();
            this.$awn.success(res.data);
          },
          err => {
            this.loading = false;
            this.$awn.alert(err.response.data);
          }
        );
      }
    },
    showUpdateEmail: function(item) {
      this.selected = item;
      this.emailDialog = true;
    },
    updateEmail: function() {
      apiv1({
        method: "PUT",
        url: `user/update-email/${this.selected.id}`,
        data: { email: this.selected.email }
      }).then(res => {
        this.emailDialog = false;
        this.getUsers();
        this.$awn.success(res.data);
      });
    },
    deleteUsuario: function(item) {
      this.$swal({
        title: "Continuar?",
        text: `¿Seguro que desea eliminar el usuario '${item.name.toUpperCase()}'?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, deseo eliminarlo",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$awn.async(
            apiv1({
              method: "DELETE",
              url: `user/${item.id}`
            }),
            res => {
              this.getUsers();
              this.$awn.success(res.data);
            },
            err => this.$awn.alert(err.response.data)
          );
        }
      });
    },
    getAssignedCecos: function() {
      apiv1({
        method: "GET",
        url: `user/assigned-cecos/${this.selected.id}`
      }).then(res => {
        this.selectedCecos = res.data.map(function(item) {
          return item.ceco;
        });
      });
    },
    assignCecos: function() {
      apiv1({
        method: "POST",
        url: `user/assign-cecos`,
        data: {
          cecos: this.selectedCecos,
          usuario: this.selected.id
        }
      }).then(res => {
        this.selectedCecos = [];
        this.asignCecos = false;
        this.$awn.success(res.data);
      });
    }
  }
});


</script>

<style>
</style>